import { render, staticRenderFns } from "./SentimentsOEM.vue?vue&type=template&id=3595a4db&scoped=true"
import script from "./SentimentsOEM.vue?vue&type=script&lang=js"
export * from "./SentimentsOEM.vue?vue&type=script&lang=js"
import style0 from "./SentimentsOEM.vue?vue&type=style&index=0&id=3595a4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595a4db",
  null
  
)

export default component.exports